/**
 * Shared bar showing the active firm case context.
 * Shown on /chat, /disc, /pleadings when in firm mode and a case is selected.
 * Uses FirmModeContext; styles from UnifiedPage.css (imported by parent pages).
 */
import React from 'react';
import { useFirmMode } from '../contexts/FirmModeContext';

export default function FirmCaseContextBar() {
  const { isFirmMode, activeFirmCase, clearActiveFirmCase } = useFirmMode();

  if (!isFirmMode || !activeFirmCase) return null;

  return (
    <div className="firm-case-context-bar">
      <span className="firm-case-context-label">
        Using firm case context: {activeFirmCase.title || 'Untitled'}
        {activeFirmCase.caseNumber ? ` / ${activeFirmCase.caseNumber}` : ''}
      </span>
      <button
        type="button"
        className="firm-case-context-clear"
        onClick={clearActiveFirmCase}
        aria-label="Clear firm case context"
      >
        Clear
      </button>
    </div>
  );
}
